<script>

  export let expertID;
  export let color;

  import experts from '../data/experts.js';

  $: expert = experts.find(o => o.id === expertID);
  $: imgpath = expert.name.toLowerCase().replace(/\s|(\.)|\(|\)/g, '');

</script>

<style type="text/sass">

.wrap
  display: flex
  min-height: 45vh

.col:first-child
  flex: 1
.col:last-child
  flex: 2

.image
  background-size: cover
  background-position: center
  background-repeat: no-repeat
  background-blend-mode: saturation

.bio
  background: white
  display: flex
  align-items: center
  justify-content: center
  line-height: 1.4

  > *
    margin: auto
    padding: 3em 3em 2em
    font-size: 19px

  h1
    margin-top: 0
    position: relative

  h3
    color: #888
    text-transform: uppercase
    font-size: 18px
    margin-top: -1em

  h4
    font-size: 16px
    letter-spacing: 0.05em
    margin: 0

  span
    margin-left: 1em
    position: absolute
    bottom: 6px

  a
    float: right
    height: 1em
    width: 1em
    line-height: 1em
    text-align: center

    &:last-child
      margin-right: 5px

  .socials

    svg
      transition-duration: 0.3s
      transition-timing-function: ease

    &:hover svg
      opacity: 0.7
      transform: scale(0.95)

    &:hover svg:hover
      opacity: 1
      transform: scale(1.05)


@media (max-width: 800px)

  .wrap
    flex-direction: column
    min-height: 80vh

  .image
    min-height: 50vh

  .bio

    > *
      padding: 2em 1.5em 2em

    h1
      font-size: 1.5em

    h3
      font-size: 16px

    span
      margin-left: 0
      position: absolute
      top: 0px
      right: 0

      a + a
        padding-right: 1em

    a
      float: none
      position: absolute
      right: 0


</style>

<div class="wrap">

  <div class="col image" style="background-image: url(../static/img/profiles/{imgpath}.jpg)">
  </div>
  <div class="col bio">
    <div>
      <h4 style="color: {color}">
        {#if expertID != 10} THE EXPERT
        {:else} WHO WE ASKED
        {/if}
      </h4>
      <h1> {expert.name}
        <span class="socials">
          {#if expert.twitter}
            <a id='twitter' target="_blank" href="https://twitter.com/{expert.twitter}">
              <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 20"><path d="M18.89 7.012c.808-.496 1.343-1.173 1.605-2.034-.786.417-1.569.703-2.351.861-.703-.756-1.593-1.14-2.66-1.14-1.043 0-1.924.366-2.643 1.078-.715.717-1.076 1.588-1.076 2.605 0 .309.039.585.117.819-3.076-.105-5.622-1.381-7.628-3.837-.34.601-.51 1.213-.51 1.846 0 1.301.549 2.332 1.645 3.089-.625-.053-1.176-.211-1.645-.47 0 .929.273 1.705.82 2.388.549.676 1.254 1.107 2.115 1.291-.312.08-.641.118-.979.118-.312 0-.533-.026-.664-.083.23.757.664 1.371 1.291 1.841.625.472 1.344.721 2.152.743-1.332 1.045-2.855 1.562-4.578 1.562-.422 0-.721-.006-.902-.038 1.697 1.102 3.586 1.649 5.676 1.649 2.139 0 4.029-.542 5.674-1.626 1.645-1.078 2.859-2.408 3.639-3.974.784-1.564 1.172-3.192 1.172-4.892v-.468c.758-.57 1.371-1.212 1.84-1.921-.68.293-1.383.492-2.11.593z"/></svg>
            </a>
          {/if}
          {#if expert.linkedin}
            <a id='linkedin' target="_blank" href='https://www.linkedin.com/in/{expert.linkedin}'>
              <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="2 1 20 20"><path d="M8 19h-3v-10h3v10zm11 0h-3v-5.342c0-1.392-.496-2.085-1.479-2.085-.779 0-1.273.388-1.521 1.165v6.262h-3s.04-9 0-10h2.368l.183 2h.062c.615-1 1.598-1.678 2.946-1.678 1.025 0 1.854.285 2.487 1.001.637.717.954 1.679.954 3.03v5.647z"/><ellipse cx="6.5" cy="6.5" rx="1.55" ry="1.5"/></svg>
            </a>
          {/if}
        </span>
      </h1>
      <h3>{expert.position}</h3>
      <p>{@html expert.bio}</p>
    </div>
  </div>

</div>
